<template>
  <div class="question-category-select" @change="onChange">
    <select v-model="currentSelected" class="question-category-select__input">
      <option
        v-for="category in categories"
        :key="category.name"
        class="question-category-select__option"
        :value="category"
      >
        {{ category.label }}
      </option>
    </select>
    <div class="question-category-select__label">
      <i
        :class="`icon icon--${currentSelected.icon} question-category-select__icon`"
      ></i>
      <span v-text="currentSelected.label"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionCategorySelect',
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentSelected: this.categories[0],
    };
  },
  methods: {
    onChange() {
      const categories = document.querySelectorAll('.page-faq__category');

      categories.forEach(category => {
        if (category.dataset.category === this.currentSelected.name) {
          category.classList.remove(category.dataset.hiddenClass);
        } else {
          category.classList.add(category.dataset.hiddenClass);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.question-category-select {
  $block-selector: &;

  position: relative;
  width: 100%;
  height: 3.43em;
  transform: translateY(-50%);

  &__input {
    appearance: none;
    border: 0;
    outline: 0;
    background-color: $color-primary;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI3Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMCAwIDcgNyA3LTdaIi8+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: 95% center;
    text-align: center;
    padding: 0.75em;
    width: 100%;
    height: 100%;
    color: transparent;
    cursor: pointer;

    &::-ms-expand {
      display: none;
    }

    &:focus {
      outline: none;
    }

    @include breakpoint($breakpoint-m) {
      display: none;
    }
  }

  &__label {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.625em;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    color: $color-white;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
  }
}
</style>
